import { Provider } from "react-redux";
import { ThemeProvider } from "next-themes";
import VideoPlayer from "./videoPlayer";
import store from "redux-share/store";
import { IParams } from "interfaces";
import { memo } from "react";

export const domains = require('configs/imageDomains/imageDomains');

const VideoPlayerLibrary = (props: IParams) => {
    return (
        <Provider store={store}>
            <ThemeProvider enableSystem={true} attribute="class">
                <VideoPlayer params={props} />
            </ThemeProvider>
        </Provider>
    )
}

export default memo(VideoPlayerLibrary);
